/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import AppBar from "@mui/material/AppBar";
import PaletteIcon from '@mui/icons-material/Palette';
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import MenuItem from "@mui/material/MenuItem";
import HouseSidingIcon from "@mui/icons-material/HouseSiding";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import LogoutIcon from "@mui/icons-material/Logout";
import { styled } from "@mui/material/styles";
import MenuList from "@mui/material/MenuList";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";
import useIsMobileViewport from "../../../hooks/useIsMobileViewport";
import { useAppContext } from "../../../contexts/useStorageContext";
import { actionTypes } from "../../../types/state";
import UserFormDialog from "../../pages/users/UserFormDialog";
import { IUser } from "../../../types/user";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import ActionButtonGroup from "../../pages/home/ActionButtonGroup";
import { Button, Chip, Tooltip } from "@mui/material";
import useThemeMode from "../../../hooks/useThemeMode";
import companyService from "../../../service/company.service";
import sampleRecordService from "../../../service/sampleRecord.service";
import { ICompany } from "../../../types/company";
import userService from "../../../service/user.service";
import { NotificationIconButton } from "./NotificationIconButton";
import QuickActionsDialog from "../QuickActions/QuickActionsDialog";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import GeneralPopoverWrapper from "../Common/GeneralPopoverWrapper";
import { UserRoles } from "../../../types/auth";
import ChamberReportDialog from "../QuickActions/ChamberReport/ChamberReportDialog";
import settingsService from "../../../service/settings.service";
import { AnalysisValueRanges } from "../Common/GasAnalysisReport/AnalysisConstants";
import { sliderRanges } from "../QuickActions/ChamberReport/columns";
import ColorPreferencesDialog from "../User/ColorPreferencesDialog";
import { logout } from "../../../helpers/logout";
import { loadCropTypes } from "../../../helpers/loadCropTypes";
const Navbar = styled(AppBar)(() => ({
  flexGrow: 1,
  marginLeft: 0,
  width: "100%",
  boxShadow: "none",
}));

export default function NavBar() {
  const { dispatch, state } = useAppContext();
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const navigation = useNavigate();
  const { openSideDrawer, loggedInUserInfo, myCompanyProfile } = state;
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );
  const [openUserFormDialog, setOpenUserFormDialog] = React.useState(false);
  const [lastChemSsid, setLastChemSsid] = React.useState<number>(0);
  const [lastSpecSsid, setLastSpecSsid] = React.useState<number>(0);
  const [loadingLastSsids, setLoadingLastSsids] = React.useState(false);
  const [selectedCompany, setSelectedCompany] = React.useState<
    ICompany | undefined
  >();
  const [openQuickActionsDialog, setOpenQuickActionsDialog] =
    React.useState(false);
  const [openChamberReportDialog, setOpenChamberReportDialog] =
    React.useState(false);
  const [openColorPreferencesDialog, setOpenColorPreferencesDialog] =
    React.useState(false);
  const [anchorElTheme, setAnchorElTheme] = React.useState<null | HTMLElement>(
    null
  );
  const { mode: themeMode, resolvedMode, setMode } = useThemeMode();
  const isMobile = useIsMobileViewport();

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const fetchLastSSIDs = async () => {
    const companyId = selectedCompany?._id || selectedCompany?._id;
    if (!companyId) {
      setLastChemSsid(0);
      setLastSpecSsid(0);
      return;
    }
    setLoadingLastSsids(true);
    const result = await sampleRecordService.getLastSSIDs(companyId);
    setLastChemSsid(result.chem || 0);
    setLastSpecSsid(result.spec || 0);
    setLoadingLastSsids(false);
  };

  const fetchMyCompanyProfile = async () => {
    if (!loggedInUserInfo?.company) return;
    const [myCompanyResult, myProfile, myClients] = await Promise.all([
      companyService.getMyCompany(),
      userService.getMyProfile(),
      companyService.getMyClients(),
    ]);
    dispatch!({
      type: actionTypes.setLoggedInUserInfo,
      value: { ...(loggedInUserInfo || {}), ...(myProfile || {}) },
    });
    setSelectedCompany(myCompanyResult.data);
    if (myCompanyResult.data?._id) {
      dispatch!({
        type: actionTypes.setMyCompanyProfile,
        value: myCompanyResult.data,
      });
    }
    dispatch!({ type: actionTypes.setMyClients, value: myClients.data });
  };

  const fetchSettings = async () => {
    const result = await settingsService.getSettings();
    dispatch!({
      type: actionTypes.setGasReportValueRanges,
      value: result?.gasReportValueRanges?.length
        ? result.gasReportValueRanges.reduce(
            (
              acc: { [key: string]: { min: number; max: number; heatmapAvailable?: boolean } },
              curr: { field: string; min: number; max: number; heatmapAvailable?: boolean }
            ) => {
              acc[curr.field] = { min: curr.min, max: curr.max, heatmapAvailable: curr.heatmapAvailable };
              return acc;
            },
            {} as { [key: string]: { min: number; max: number; heatmapAvailable?: boolean } }
          )
        : AnalysisValueRanges,
    });
    dispatch!({
      type: actionTypes.setChamberReportValueRanges,
      value: result?.chamberReportValueRanges?.length
        ? result.chamberReportValueRanges.reduce(
            (
              acc: { [key: string]: { min: number; max: number } },
              curr: { field: string; min: number; max: number }
            ) => {
              acc[curr.field] = { min: curr.min, max: curr.max };
              return acc;
            },
            {} as { [key: string]: { min: number; max: number } }
          )
        : sliderRanges,
    });
  };

  React.useEffect(() => {
    fetchLastSSIDs();
  }, [selectedCompany, myCompanyProfile]);

  React.useEffect(() => {
    fetchMyCompanyProfile();
    fetchSettings();
    loadCropTypes(dispatch);
  }, []);

  return (
    <Navbar
      position="fixed"
      elevation={1}
      sx={{
        bgcolor: "navbar.default",
        borderBottom: "solid 1px #e5e5e5",
        flex: "unset",
        zIndex: 1,
      }}
    >
      <Box>
        <Box sx={{ px: { xs: 0, sm: 2 } }}>
          <Toolbar disableGutters sx={{ minHeight: { xl: "72px" } }}>
            {/* {!isMobile && ( */}
              <IconButton
                size={
                  isMobile ? "small" : "medium"
                }
                onClick={() =>
                  dispatch!({
                    type: actionTypes.setOpenSideDrawer,
                    value: !openSideDrawer,
                  })
                }
              >
                <MenuIcon
                  sx={{
                    color: "button.black",
                    fontSize: { xs: "30px", lg: "35px" },
                  }}
                />
              </IconButton>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                ml: { xs: 1, md: 2 },
                maxWidth: {
                  sm: "unset",
                },
                overflow: "hidden",
              }}
            >
              <div>     
                <div style={{ display:"flex", alignItems:"center" }}>          
                <Box
                  component="img"
                  src="/biofluxe.svg"
                  alt="Orugen Datalake Logo"
                  sx={{
                    backgroundColor: "#0000",
                    maxHeight: { xs: "30px", md: "50px" },
                    filter: (theme) =>
                      theme.palette.mode === "dark"
                        ? "invert(1) hue-rotate(180deg)"
                        : "none",
                  }}
                />
                {                  
                  !isMobile && window.env.BACKEND_API_URL?.includes("dev")?
                  <Chip label="DEV" color="warning" sx={{
                    maxHeight:"24px",
                    fontSize:"12px",
                    fontWeight:"bold",
                    padding:"0px 0px !important",
                    "& .MuiChip-label": {
                      padding:"0px 6px"
                    },
                    ml:"4px"
                  }}/>:null                  
                }
                </div>
                {
                  isMobile ? <Box sx={{
                    color: "text.secondary",
                    fontSize: "9px",
                    marginTop:"-5px",
                    marginLeft:"4px",
                    display:"flex",
                    alignItems:"center",
                  }}>MOBILE VIEW
                  {
                    window.env.BACKEND_API_URL?.includes("dev")?
                    <Chip label="DEV" color="warning" sx={{
                      maxHeight:"14px",
                      fontSize:"9px",
                      fontWeight:"bold",
                      padding:"0px 0px !important",
                      "& .MuiChip-label": {
                        padding:"0px 6px"
                      },
                      ml:"4px"
                    }}/>:null
                  }
                  </Box>:null
                }
              </div>
            </Box>
            <Box
              sx={{
                px: { xs: 0, sm: 1 },
                flexGrow: 1,
                alignItems: "center",
                justifyContent: "flex-end",
                display: { xs: "flex" },
              }}
            >
              {/* <CompanyAutoComplete
                value={selectedCompany}
                onChange={(selected) =>
                  setSelectedCompany(selected || undefined)
                }
              /> */}
              {/* <Box
                sx={{
                  color: "#888",
                  fontSize: "12px",
                  marginRight: "20px",
                  borderLeft: "solid 2px #dedede",
                  paddingLeft: "6px",
                  display: { xs: "none", sm: "block" },
                  ml: 1,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>Last Chem SSID: </div>
                  {loadingLastSsids ? (
                    <CircularProgress size={12} sx={{ ml: 1 }} />
                  ) : (
                    <Box sx={{ color: "warning.main", ml: "5px" }}>
                      {lastChemSsid || "?"}
                    </Box>
                  )}
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>Last Spectra SSID: </div>
                  {loadingLastSsids ? (
                    <CircularProgress size={12} sx={{ ml: 1 }} />
                  ) : (
                    <Box sx={{ color: "warning.main", ml: "5px" }}>
                      {lastSpecSsid || "?"}
                    </Box>
                  )}
                </div>
              </Box> */}
              {!isMobile &&
              loggedInUserInfo?.role === UserRoles.superadmin ? (
                <div>
                  <Button
                    onClick={() => setOpenQuickActionsDialog(true)}
                    color="warning"
                    sx={{
                      display: { xs: "none", md: "flex" },
                      padding: { xs: "4px 4px 4px 12px" },
                      minHeight: "32px",
                      mr: 1,
                    }}
                    variant="outlined"
                    startIcon={<RocketLaunchIcon />}
                  >
                    <Box
                      sx={{ display: { xs: "none", md: "block" }, mr: "4px" }}
                    >
                      {`${t("Ledger")}`}
                    </Box>
                  </Button>
                  <Tooltip title={`${t("Ledger")} (${t("Quick Actions")})`}>
                    <IconButton
                    size={
                      isMobile ? "small" : "medium"
                    }
                      onClick={() => setOpenQuickActionsDialog(true)}
                      color="warning"
                      sx={{ display: { xs: "flex", md: "none" } }}
                    >
                      <RocketLaunchIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              ) : null}

              {!isMobile &&
              loggedInUserInfo?.role === UserRoles.superadmin ? (
                <div>
                  <Button
                    size={
                      isMobile ? "small" : "medium"
                    }
                    onClick={() => setOpenChamberReportDialog(true)}
                    color="warning"
                    sx={{
                      display: { xs: "none", md: "flex" },
                      padding: { xs: "4px 4px 4px 12px" },
                      minHeight: "32px",
                      mr: 1,
                    }}
                    variant="outlined"
                    startIcon={<HouseSidingIcon />}
                  >
                    <Box
                      sx={{ display: { xs: "none", md: "block" }, mr: "4px" }}
                    >
                      {`${t("Chamber Report")}`}
                    </Box>
                  </Button>
                  <Tooltip title={`${t("Chamber Report")}`}>
                    <IconButton
                      size={
                        isMobile ? "small" : "medium"
                      }
                      onClick={() => setOpenChamberReportDialog(true)}
                      color="warning"
                      sx={{ display: { xs: "flex", md: "none" } }}
                    >
                      <HouseSidingIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              ) : null}
              <ActionButtonGroup
                size={isMobile ? "small" : "medium"}
                lastChemSsid={lastChemSsid}
                lastSpecSsid={lastSpecSsid}
                contactOnly={isMobile}
              />
            </Box>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "8px",
              }}
            >
              <Tooltip
                title={
                  themeMode === "system"
                    ? `${t("Theme")}: ${t("System")} (${
                        resolvedMode === "dark" ? t("Dark") : t("Light")
                      })`
                    : `${t("Theme")}: ${
                        resolvedMode === "dark" ? t("Dark") : t("Light")
                      }`
                }
              >
                <IconButton
                  size={
                    isMobile ? "small" : "medium"
                  }
                  onClick={(e) => setAnchorElTheme(e.currentTarget)}
                  sx={{ mr: "12px" }}
                  aria-label="Toggle theme"
                >
                  {themeMode === "system" ? (
                    <SettingsBrightnessIcon />
                  ) : resolvedMode === "dark" ? (
                    <DarkModeIcon />
                  ) : (
                    <LightModeIcon />
                  )}
                </IconButton>
              </Tooltip>
              <Popover
                open={Boolean(anchorElTheme)}
                anchorEl={anchorElTheme}
                onClose={() => setAnchorElTheme(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <MenuList>
                  <MenuItem
                    selected={themeMode === "light"}
                    onClick={() => {
                      setMode("light");
                      setAnchorElTheme(null);
                    }}
                  >
                    <ListItemIcon>
                      <LightModeIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{t("Light")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    selected={themeMode === "dark"}
                    onClick={() => {
                      setMode("dark");
                      setAnchorElTheme(null);
                    }}
                  >
                    <ListItemIcon>
                      <DarkModeIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{t("Dark")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    selected={themeMode === "system"}
                    onClick={() => {
                      setMode("system");
                      setAnchorElTheme(null);
                    }}
                  >
                    <ListItemIcon>
                      <SettingsBrightnessIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{t("System")}</ListItemText>
                  </MenuItem>
                </MenuList>
              </Popover>
              <GeneralPopoverWrapper
                triggerElement={
                  <img
                    src={`/lang/${i18n.language?.split("-")[0]}-lang.png`}
                    style={{ width: "25px", height: "25px", cursor: "pointer", backgroundColor: "#0000" }}
                  />
                }
                closeOnClickContent
                popoverContent={
                  <Box>
                    <MenuItem
                      selected={i18n.language?.split("-")[0] === "en"}
                      onClick={() => {
                        i18n.changeLanguage("en");
                      }}
                    >
                      <ListItemIcon>
                        <img
                          src={`/lang/en-lang.png`}
                          style={{
                            width: "25px",
                            height: "25px",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText>{t("English")}</ListItemText>
                    </MenuItem>
                    <MenuItem
                      selected={i18n.language?.split("-")[0] === "fr"}
                      onClick={() => {
                        i18n.changeLanguage("fr");
                      }}
                    >
                      <ListItemIcon>
                        <img
                          src={`/lang/fr-lang.png`}
                          style={{ width: "25px", height: "25px" }}
                        />
                      </ListItemIcon>
                      <ListItemText>{t("French")}</ListItemText>
                    </MenuItem>
                    <MenuItem
                      selected={i18n.language?.split("-")[0] === "es"}
                      onClick={() => {
                        i18n.changeLanguage("es");
                      }}
                    >
                      <ListItemIcon>
                        <img
                          src={`/lang/es-lang.png`}
                          style={{ width: "25px", height: "25px" }}
                        />
                      </ListItemIcon>
                      <ListItemText>{t("Spanish")}</ListItemText>
                    </MenuItem>
                    <MenuItem
                      selected={i18n.language?.split("-")[0] === "ar"}
                      onClick={() => {
                        i18n.changeLanguage("ar");
                      }}
                    >
                      <ListItemIcon>
                        <img
                          src={`/lang/ar-lang.png`}
                          style={{ width: "25px", height: "25px" }}
                        />
                      </ListItemIcon>
                      <ListItemText>{t("Arabic")}</ListItemText>
                    </MenuItem>
                  </Box>
                }
              />
            </div>
            <Box sx={{ flexGrow: 0, ml: 1 }}>
              <NotificationIconButton size={isMobile ? "small" : "medium"} />
              <IconButton
                size={
                  isMobile ? "small" : "medium"
                }
                onClick={handleOpenUserMenu}
                sx={{ mr: "4px" }}
              >
                <PermIdentityIcon
                  sx={
                    {
                      // color: "button.black",
                      // fontSize: { xs: "30px", lg: "35px" },
                    }
                  }
                />
              </IconButton>

              <Popover
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <Box sx={{ minWidth: 250 }}>
                  {/* <Box
                    sx={{
                      color: "#888",
                      background: "#f1f1f1",
                      fontSize: "12px",
                      paddingLeft: "6px",
                      p: 2,
                      pb: 1,
                      display: { xs: "block", sm: "none" },
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div>Last Chem SSID: </div>
                      {loadingLastSsids ? (
                        <CircularProgress size={12} sx={{ ml: 1 }} />
                      ) : (
                        <Box sx={{ color: "warning.main", ml: "5px" }}>
                          {lastChemSsid || "N/A"}
                        </Box>
                      )}
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div>Last Spectra SSID: </div>
                      {loadingLastSsids ? (
                        <CircularProgress size={12} sx={{ ml: 1 }} />
                      ) : (
                        <Box sx={{ color: "warning.main", ml: "5px" }}>
                          {lastSpecSsid || "N/A"}
                        </Box>
                      )}
                    </div>
                  </Box> */}
                  <Box p={2} sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "#152033" : "#f3f3f3",
                        borderRadius: "100px",
                        backgroundImage: `url(${
                          loggedInUserInfo?.avatar || ""
                        })`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                      }}
                    />
                    <Box sx={{ flex: 1, ml: 1 }}>
                      <Typography variant="h6">
                        {loggedInUserInfo?.fullname}
                      </Typography>
                      <Typography variant="body2">
                        {loggedInUserInfo?.email}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider />
                  <Box>
                    <MenuList>
                      <MenuItem
                        onClick={() => {
                          setOpenUserFormDialog(true);
                        }}
                      >
                        <ListItemIcon>
                          <EditIcon />
                        </ListItemIcon>
                        <ListItemText>{t("Edit Profile")}</ListItemText>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setOpenColorPreferencesDialog(true);
                          handleCloseUserMenu();
                        }}
                      >
                        <ListItemIcon>
                          <PaletteIcon />
                        </ListItemIcon>
                        <ListItemText>Color Preferences</ListItemText>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleCloseUserMenu();
                          logout(dispatch!);
                        }}
                      >
                        <ListItemIcon>
                          <LogoutIcon />
                        </ListItemIcon>
                        <ListItemText>{t("Log out")}</ListItemText>
                      </MenuItem>
                    </MenuList>
                  </Box>
                </Box>
              </Popover>
            </Box>
          </Toolbar>
        </Box>
      </Box>
      {openUserFormDialog && (
        <UserFormDialog
          open
          user={{ ...loggedInUserInfo, company: myCompanyProfile } as IUser}
          onClose={() => setOpenUserFormDialog(false)}
          onUpdated={(updatedUser) => {
            dispatch!({
              type: actionTypes.setLoggedInUserInfo,
              value: { ...(loggedInUserInfo || {}), ...updatedUser },
            });
            setOpenUserFormDialog(false);
          }}
        />
      )}
      {openQuickActionsDialog && (
        <QuickActionsDialog onClose={() => setOpenQuickActionsDialog(false)} />
      )}
      {openChamberReportDialog && (
        <ChamberReportDialog
          onClose={() => setOpenChamberReportDialog(false)}
        />
      )}
      {openColorPreferencesDialog && (
        <ColorPreferencesDialog
          open
          onClose={() => setOpenColorPreferencesDialog(false)}
        />
      )}
    </Navbar>
  );
}
